export function handleGlobalError(mainPromise: Promise<any>) {
  return new Promise((resolve, reject) => {
    const errorHandler = (event: { stopPropagation: () => void; preventDefault: () => void; }) => {
      event.stopPropagation();
      event.preventDefault();
      reject(event);
    };

    window.addEventListener('error', errorHandler, { once: true });

    mainPromise
      .then((...args) => {
        window.removeEventListener('error', errorHandler);
        resolve(...args);
      })
      .catch((...args) => {
        window.removeEventListener('error', errorHandler);
        reject(...args);
      });
  });
}
